
import TituloNegrito from './TituloNegrito'
import CardProdutoGenerico from './CardProdutoGenerico'

import { retornarTexto } from '../helpers/textoHelper'

function ProdutosCertificadosDuroc({ produtos, exibirMenu, resolucaoMobile, idioma, slugEmpresa }) {
    function produtoExisteNoIdiomaSelecionado(produto) {
        let exibirProduto = false

        if (idioma === 'pt') {
            exibirProduto = true
        } else if (idioma === 'en') {
            if (produto['Descrição do produto (Inglês)']) {
                exibirProduto = true
            }
        } else if (idioma === 'es') {
            if (produto['Descrição do produto (Espanhol)']) {
                exibirProduto = true
            }
        } else if (idioma === 'fr') {
            if (produto['Descrição do produto (Francês)']) {
                exibirProduto = true
            }
        }

        return exibirProduto
    }

    return (
        <>
            <TituloNegrito texto={retornarTexto(idioma, 'produtosCertificados')} />
            <div style={{ width: '80vw' }} className='mb-2 d-flex flex-column align-items-center justify-content-center'>
                <div style={{ gap: '20px' }} className='mb-2 mt-5 d-flex flex-wrap align-items-center justify-content-center'>
                    {produtos?.filter((produto) => produtoExisteNoIdiomaSelecionado(produto)).map((produto) => <CardProdutoGenerico key={produto['Nome do produto/serviço']} exibirMenu={exibirMenu} produto={produto} resolucaoMobile={resolucaoMobile} idioma={idioma} slugEmpresa={slugEmpresa} pathCatalogo={'catalogo-duroc'} />)}
                </div>
            </div>
        </>
    );
}
export default ProdutosCertificadosDuroc;
